<header class="fc-header" [class.scrolled]="isScrolled">
  <div class="fc-header-inner">
    <!-- LOGO -->
    <a [routerLink]="['/']" class="fc-logo" (click)="scrollToTop()" aria-label="FundCube - Página inicial">
      <img src="images/fundCubeLogo.png" alt="FundCube" class="fc-logo-img" />
    </a>

    <!-- SEARCH BAR -->
    <div class="fc-search">
      <i class="fas fa-search fc-search-icon"></i>
      <input type="text" placeholder="Pesquisar campanhas..." (keydown.enter)="onSearch($event)" />
    </div>

    <!-- NAVIGATION LINKS -->
    <nav class="fc-nav">
      <a [routerLink]="['/']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="fc-nav-link"
        (click)="scrollToTop()">
        Início
      </a>
      <a [routerLink]="['/campanhas']" routerLinkActive="active" class="fc-nav-link">
        Explorar
      </a>
      <a [routerLink]="['/sobre-nos']" routerLinkActive="active" class="fc-nav-link">
        Sobre Nós
      </a>
      <a [routerLink]="['/perguntas-frequentes']" routerLinkActive="active" class="fc-nav-link">
        FAQs
      </a>
    </nav>

    <!-- ACTIONS -->
    <div class="fc-actions">
      <button type="button" class="btn btn-primary btn-sm btn-rounded hide-xs" (click)="callRouteCreateCampanha()">
        <i class="fas fa-plus"></i>
        <span>Criar Campanha</span>
      </button>

      <!-- AUTH BUTTONS -->
      <ng-container *ngIf="!IsAuthenticad">
        <button type="button" class="btn btn-outline btn-sm btn-rounded hide-mobile" (click)="openLogin()">
          Iniciar sessão
        </button>
        <button type="button" class="btn btn-amber btn-sm btn-rounded hide-mobile" (click)="openRegister()">
          Registar
        </button>
      </ng-container>

      <!-- USER PROFILE WHEN AUTHENTICATED -->
      <ng-container *ngIf="IsAuthenticad">
        <div class="fc-user-menu">
          <p-avatar [label]="initials || 'U'" shape="circle" styleClass="fc-avatar" [title]="Username"
            (click)="menu.toggle($event)" role="button" tabindex="0" (keydown.enter)="menu.toggle($event)" />
          <p-menu #menu [model]="items" [popup]="true" appendTo="body" />
        </div>
      </ng-container>

      <!-- MOBILE HAMBURGER -->
      <button type="button" class="fc-hamburger" [class.open]="ShowOpenMenu" (click)="HideShowMenuMobile()"
        aria-label="Menu de navegação">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </div>
</header>

<!-- MOBILE DRAWER OVERLAY -->
<div class="fc-drawer-overlay" [class.open]="ShowOpenMenu" (click)="HideShowMenuMobile()"></div>

<!-- MOBILE DRAWER -->
<aside class="fc-drawer" [class.open]="ShowOpenMenu">
  <div class="fc-drawer-header">
    <a [routerLink]="['/']" class="fc-logo" (click)="HideShowMenuMobile()" aria-label="FundCube - Página inicial">
      <img src="images/fundCubeLogo.png" alt="FundCube" class="fc-logo-img" />
    </a>
    <button type="button" class="fc-drawer-close" (click)="HideShowMenuMobile()" aria-label="Fechar menu">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="fc-drawer-body">
    <a [routerLink]="['/']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="fc-drawer-link"
      (click)="HideShowMenuMobile()">
      <i class="fas fa-home"></i>
      <span>Início</span>
    </a>
    <a [routerLink]="['/campanhas']" routerLinkActive="active" class="fc-drawer-link" (click)="HideShowMenuMobile()">
      <i class="fas fa-compass"></i>
      <span>Explorar</span>
    </a>
    <a [routerLink]="['/sobre-nos']" routerLinkActive="active" class="fc-drawer-link" (click)="HideShowMenuMobile()">
      <i class="fas fa-info-circle"></i>
      <span>Sobre Nós</span>
    </a>
    <a [routerLink]="['/perguntas-frequentes']" routerLinkActive="active" class="fc-drawer-link"
      (click)="HideShowMenuMobile()">
      <i class="fas fa-question-circle"></i>
      <span>FAQs</span>
    </a>

    <div class="fc-drawer-divider"></div>

    <!-- USER ACTIONS IN MOBILE DRAWER: ADMINISTRADOR (SE ADMIN), ÁREA DO UTILIZADOR E TERMINAR SESSÃO -->
    <ng-container *ngIf="IsAuthenticad">
      <button *ngIf="isAdmin" type="button" class="fc-drawer-link" (click)="goToAdmin(); HideShowMenuMobile()">
        <i class="fas fa-shield-alt"></i>
        <span>Administrador</span>
      </button>
      <button type="button" class="fc-drawer-link" (click)="goToUserArea(); HideShowMenuMobile()">
        <i class="fas fa-user-circle"></i>
        <span>Área do Utilizador</span>
      </button>
      <button type="button" class="fc-drawer-link fc-drawer-logout" (click)="logout(); HideShowMenuMobile()">
        <i class="fas fa-sign-out-alt"></i>
        <span>Terminar Sessão</span>
      </button>
    </ng-container>
  </div>

  <div class="fc-drawer-footer">
    <button type="button" class="btn btn-primary btn-full btn-rounded"
      (click)="callRouteCreateCampanha(); HideShowMenuMobile()">
      <i class="fas fa-plus"></i> Criar Campanha
    </button>

    <ng-container *ngIf="!IsAuthenticad">
      <button type="button" class="btn btn-outline btn-full btn-rounded" (click)="openLogin(); HideShowMenuMobile()">
        Iniciar Sessão
      </button>
      <button type="button" class="btn btn-amber btn-full btn-rounded" (click)="openRegister(); HideShowMenuMobile()">
        Registar Conta
      </button>
    </ng-container>
  </div>
</aside>